exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn-negative[data-v-1ee5bebe] {\n  font-size: 15px;\n  font-weight: 400;\n  margin-top: 0;\n}\n.image-upload[data-v-1ee5bebe] {\n  display: inline-block;\n  width: auto;\n  text-align: center;\n}\n", ""]);

// exports
